<template>
  <div
    class="preview"
    :class="isSelected ? 'selectedPreview' : ''"
    @click="select"
    :disabled="isSelected"
  >
    <div class="details">
      <div class="core-details">
        <div class="name"></div>
        <div class="date">{{ startDate }}</div>
        <div class="hour">{{ startHour }}</div>
        <div
          class="verificationStatus"
          :class="
            session.users && session.users.length && session.users.length == 2
              ? 'verified'
              : 'unverified'
          "
        >
          {{
            session.users && session.users.length && session.users.length == 2
              ? "Matched"
              : "Unmatched"
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";

export default {
  name: "SessionPreview",
  props: {
    session: Object,
    isSelected: Boolean,
  },
  methods: {
    select() {
      this.$emit("select", this.session._id);
    },
  },
  computed: {
    startDate() {
      return format(new Date(this.session.dateTime), `MMMM d`);
    },
    startHour() {
      return format(new Date(this.session.dateTime), `HH:mm`);
    },
  },
};
</script>